import { useCallback, useContext } from 'react';
import translationsASW from '../../localization/translate.asw.json';
import { ENGLISH } from '../../constants';
import { TranslationContext } from '../../context/TranslationContext';
import { TranslationContextType } from '../../types/context';

export type TranslateFn = (id: string) => string;

export const useTranslate = () => {
  const context = useContext<TranslationContextType>(TranslationContext);

  if (context.isProvided === false) {
    throw new Error(
      'useTranslate must be used within a TranslationContextProvider'
    );
  }

  const { translationMap, language, isLoading } = context;

  const t: TranslateFn = useCallback(
    (id: string) => {
      if (!translationMap) {
        return '';
      }
      if (translationMap[language][id]) {
        return translationMap[language][id];
      } else if (translationMap[ENGLISH][id]) {
        return translationMap[ENGLISH][id];
      } else if (translationsASW[id]) {
        return translationsASW[id];
      } else {
        return id;
      }
    },
    [translationMap, language]
  );

  return { t, isLoading, language };
};
